import { useEffect, useRef } from 'react';

interface UseWaterfallSkeletonFundInvestmentSheetCountParams {
  fundInvestmentSheetCount: number;
  hasSettledResults: boolean;
}

export const useWaterfallSkeletonFundInvestmentSheetCount = ({
  fundInvestmentSheetCount,
  hasSettledResults,
}: UseWaterfallSkeletonFundInvestmentSheetCountParams) => {
  const lastSettledSheetCountRef = useRef(1);
  const skeletonSheetCount =
    fundInvestmentSheetCount > 0 || hasSettledResults
      ? fundInvestmentSheetCount
      : lastSettledSheetCountRef.current;

  // Preserve the last completed layout only while the next distribution has no result yet.
  useEffect(() => {
    if (hasSettledResults) {
      lastSettledSheetCountRef.current = fundInvestmentSheetCount;
    }
  }, [fundInvestmentSheetCount, hasSettledResults]);

  return skeletonSheetCount;
};
